import React, { useEffect } from "react";
import { FaUserPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import ClipLoader from "react-spinners/ClipLoader";
import { useDispatch, useSelector } from "react-redux";
import { UserAccountFollow } from "../../redux/ApiSlice/AccountProfileSlice";
import { suggestedContentBasedUser } from "../../redux/ApiSlice/RecommendationSlice";

const ContentBasedUser = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [isLoadingMore, setIsLoadingMore] = React.useState(false);
    const { loading, contentBasedUser, error, contentBasedUserNext } = useSelector((state) => state.recommendationUser);

    useEffect(() => {
        dispatch(suggestedContentBasedUser(currentPage));
    }, [dispatch, currentPage]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = window.innerHeight;

            // Check if user has scrolled to bottom (with 100px threshold)
            if (scrollTop + clientHeight >= scrollHeight - 100) {
                if (contentBasedUserNext && !loading && !isLoadingMore) {
                    setIsLoadingMore(true);
                    setCurrentPage(prev => prev + 1);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [contentBasedUserNext, loading, isLoadingMore]);

    useEffect(() => {
        if (!loading) {
            setIsLoadingMore(false);
        }
    }, [loading]);

    const handleFollowFun = async (id) => {
        try {
            const response = await dispatch(UserAccountFollow(id));
            if (response.meta.requestStatus === 'fulfilled') {
                // Refresh current data after follow
                setCurrentPage(1);
                dispatch(suggestedContentBasedUser(1));
            }
        } catch (error) {
          console.error(error);
        }
    };

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0">
                <div className="flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="text-[24px] text-black absolute top-1/2 left-2 transform -translate-y-1/2 cursor-pointer"
                    />
                    <p className="text-[16px] font-semibold text-black">
                        Content Based Friends
                    </p>
                </div>
            </div>

            {loading ?
                <div className="flex justify-center items-center h-[70vh]">
                    <ClipLoader
                        size={40}
                        color={"#000000"}
                    />
                </div>
                :
                <>
                    {contentBasedUser.map((data) => (
                        <div key={data.id} className="p-2 border-b border-gray-300 dark:border-gray-800/50 flex items-start w-full">
                            <div className="h-10 w-14">
                                <img
                                    alt={data.name}
                                    src={data.avatar_url}
                                    onClick={() => navigate(`/account/${data.id}`)}
                                    className="h-10 w-10 rounded-full object-cover cursor-pointer border border-gray-300 dark:border-gray-800/50 bg-gray-100 dark:bg-[#333333]"
                                />
                            </div>
                            <div className="flex justify-between w-full">
                                <div className="flex flex-col mt-[2px]">
                                    <p className="text-[13px] font-semibold line-clamp-1 cursor-pointer text-black dark:text-white">
                                        {data.full_name}
                                    </p>
                                    <div className="flex items-center gap-x-3 mt-0.5">
                                        <p className="text-[10px] text-gray-500">
                                            Followers <span className="font-semibold">{data.followers_count}</span>
                                        </p>
                                        <p className="text-[10px] text-gray-500">
                                            Following <span className="font-semibold">{data.following_count}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="flex items-start gap-2">
                                    <button
                                        onClick={() => handleFollowFun(data.id)}
                                        className="flex items-center gap-x-2 bg-[#BDE6FF] text-black px-3 py-1 rounded-full text-[11px] font-semibold"
                                    >
                                        Follow <FaUserPlus />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </>
            }

            {error &&
                <div className="flex justify-center items-center h-[70vh]">
                    <p className="text-[10px] text-red-500">Error: {error}</p>
                </div>
            }

            {!loading && !error && contentBasedUser.length === 0 && (
                <div className="flex justify-center items-center h-[69vh]">
                    <p className="text-[12px] text-gray-500">
                        No Content Based Recommended Friends Found.
                    </p>
                </div>
            )}

            {isLoadingMore && contentBasedUserNext && (
                <div className="flex justify-center items-center py-4">
                    <ClipLoader
                        size={30}
                        color={"#3b82f6"}
                    />
                </div>
            )}
        </div>
    )
}

export default ContentBasedUser